import { memo } from 'react';
import ToggleSwitch from './ToggleSwitch/ToggleSwitch';
import Arrow from '../../assets/images/next-pre.svg';
import ArrowBack from '../../assets/images/chevrons-left.svg';
import { CustomSelect } from '../../shared/CustomSelect';
import { IndicatorSeparator } from './Tabs/Settings/Subsettings/ActivitySettings';

const GraddingRightBar = memo(({ isMinimized, setIsMinimized = () => {}, gradeAnswer, actIndex, activities = [], setCurrentActivity, length, handleActivityChange, isNoMore, activity, setActIndex }) => (
  <div className={`gradding_side_bar ${isMinimized ? 'minimized' : ''}`}>
    <div className='side_bar_wrapper'>
      <div className='sidebar_top_buttons_wrapper'>
        {isMinimized && (
          <div
            className='maximize_wrapper cursor'
            onClick={() => {
              setIsMinimized(false);
            }}
          >
            <img src={ArrowBack} alt='' />
          </div>
        )}
        {!isMinimized && (
          <div className='sidebar_dropdown'>
            <CustomSelect
              className='w-100'
              options={activities.map((item) => ({
                label: item.title,
                value: item._id,
                ...item,
              }))}
              components={{ IndicatorSeparator }}
              handleChange={(event) => {
                setCurrentActivity(event);
                const index = activities.findIndex((item) => item._id === event._id);
                setActIndex(index);
              }}
              value={
                {...activity, label:activity.title||'Select an activity', value:activity._id||0}
              }
              // value={
              //   activities
              //     .filter((item) => item._id === activity?._id)
              //     .map((item) => ({
              //       label: item.title,
              //       value: item.value,
              //     }))?.[0]
              // }
            />
          </div>
        )}
        <button
          className='navigational_buttons'
          disabled={actIndex === 0}
          onClick={() => {
            handleActivityChange(actIndex - 1);
          }}
        >
          {!isMinimized ? 'Prior Activity' : ''}
          <img
            src={Arrow}
            alt='next'
            style={{
              transform: 'rotate(-90deg)',
              marginLeft: `${!isMinimized ? '10px' : ''}`,
            }}
          />
        </button>

        <button
          className='navigational_buttons'
          disabled={actIndex === length - 1}
          onClick={() => {
            handleActivityChange(actIndex + 1);
          }}
        >
          {!isMinimized ? 'Next Activity' : ''}
          <img
            src={Arrow}
            alt='pre'
            style={{
              marginLeft: `${!isMinimized ? '10px' : ''}`,
              transform: 'rotate(90deg)',
            }}
          />{' '}
        </button>
        {!isMinimized && (
          <div className='side_bar_toggles'>
            <ToggleSwitch label={'Randomize order'} />
            <ToggleSwitch label={'Show names'} />
            <ToggleSwitch label={'Show grade'} />
          </div>
        )}
      </div>
      {!isMinimized && (
        <div className='sidebar_bottom_button'>
          <button onClick={gradeAnswer} disabled={isNoMore}>
            Done
          </button>
        </div>
      )}
    </div>
    <div className='rightbar_strapps' style={{ justifyContent: 'end' }}>
      <div className='strap_1' style={{ width: '4px' }}></div>
      <div className='strap_2' style={{ width: '6px' }}></div>
      <div className='strap_3' style={{ width: '8px' }}></div>
    </div>
  </div>
));
export default GraddingRightBar;
